import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

productCountStyles.wrapper = {
    ...productCountStyles.wrapper,

    css: css`
        margin: 0;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.49;
        margin-bottom: 18px;

        ${mediaQueriesBP.minMD} {
            padding-right: 10px;
            margin-bottom: 0;
        }
    `,
};
